export var AI_MATE_EXPERIENCE_ID = 'ai-mate';
export var ASSISTANCE_SERVICE_ERROR_CODES = {
  AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
  USER_NOT_CREATOR: 'errorIncorrectOwner',
  AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
  AGENT_DEACTIVATED: 'convoai.rest.bad.request.archived.agent',
  ROVO_PRODUCT_NOT_ACTIVE: 'convoai.rest.rovo.product.not.active',
  HAS_HIPAA_ENABLED: 'convoai.rest.browsing.product.has.hipaa.enabled',
  FILE_SIZE_TOO_LARGE: 'convoai.rest.bad.request.file.size.too.large'
};
export var STATUS_CODES = {
  UNSUPPORTED_FILE_TYPE: 415
};